<template>
    <CommonBox :title="titles[updateType]" @close="$emit('close')" @submit="submit">
        <el-form ref="form" label-width="150px" :model="initForm" :rules="rules">
            <el-form-item label="Product Name" prop="ProductName">
                <el-input v-model="initForm.ProductName"></el-input>
            </el-form-item>

             <el-form-item label="Product Number" prop="ProductNumber">
                <el-input v-model="initForm.ProductNumber"></el-input>
            </el-form-item>

        </el-form>
    </CommonBox>
</template>

<script>
import CommonBox from "@/components/common/CommonBox.vue";
export default {
    components:{
        CommonBox
    },
    props:{
        updateType:{},
        initForm:{}
    },
    data () {
        return {
            titles:{
                add:"Add Product",
                edit:"Edit Product"
            },
            rules:{
                ProductName:[{required: true, message: 'Please enter a product name', trigger: 'blur'}],
                ProductNumber:[{required: true, message: 'Please enter a product number', trigger: 'change'}]
            }};
    },
    created () {},
    methods:{
        submit () {
            this.$refs.form.validate((valid) => {
                if(!valid) return false;
                let methods = this.updateType === 'add' ? 'post' : 'put';
                let url = this.updateType === 'add' ? 'addProductNumber' : 'editProductNumber';
                this.$http[methods](url,this.initForm,(data)=>{
                    this.$baseNotice.message(data.msg);
                    this.$emit('close');
                    this.$emit('update');
                });
            });
        }
    }
};
</script>
